var p = (o, m, e) => new Promise((a, f) => {
  var d = (r) => {
    try {
      t(e.next(r));
    } catch (i) {
      f(i);
    }
  }, s = (r) => {
    try {
      t(e.throw(r));
    } catch (i) {
      f(i);
    }
  }, t = (r) => r.done ? a(r.value) : Promise.resolve(r.value).then(d, s);
  t((e = e.apply(o, m)).next());
});
import { jsxs as h, jsx as n } from "react/jsx-runtime";
import { useEffect as c } from "react";
import { ThemeProvider as l } from "styled-components";
import { FontLoader as T } from "./FontLoader.es.js";
import { GlobalStyle as u } from "./styles.es.js";
import { deepMerge as v } from "./utils.es.js";
import { main as x } from "./themes/main/index.es.js";
function G({
  children: o,
  theme: m = {}
}) {
  const e = v(x, m);
  return c(() => {
    p(this, null, function* () {
      yield import("react-phone-input-2/lib/style.css");
    });
  }, []), /* @__PURE__ */ h(l, { theme: e, children: [
    /* @__PURE__ */ n(T, {}),
    /* @__PURE__ */ n(u, {}),
    o
  ] });
}
export {
  G as ThemeProvider
};
//# sourceMappingURL=ThemeProvider.es.js.map
